
function stickyFooter() {
    if($(".container").hasClass("cart-empty")){
        var pageContentHeight=$(document).height();
        var deviceContentHeight=$(window).height();
        if(pageContentHeight <= deviceContentHeight ) {
            $('#footercontent').addClass('footer-bottom');
        }
    }
    
}

// Function to add business days
// function addBusinessDays(startDate, daysToAdd) {
//     let currentDate = new Date(startDate);
//     while (daysToAdd > 0) {
//         currentDate.setDate(currentDate.getDate() + 1);
//         if (currentDate.getDay() !== 0 && currentDate.getDay() !== 6) {
//             daysToAdd--;
//         }
//     }
//     return currentDate;
// }

// function datePickerCPS() {
//     // Get current date
//     const today = new Date();
    
//     // Calculate minimum date (3 business days including today)
//     const minDate = addBusinessDays(today, 3);
//     const minDateWithoutTime = new Date(minDate).setHours(0, 0, 0, 0);
    
//     // Format date for input min attribute (YYYY-MM-DD)
//     const minDateString = minDate.toISOString().split('T')[0];
    
//     // Set minimum date for the input
//     const dateInput = document.getElementById('serviceStartDate');
//     dateInput.min = minDateString;
    
//     // Handle date selection
//     dateInput.addEventListener('change', function() {
//         const selectedDate = new Date(this.value); // 'T' + today.toTimeString().split(' ')[0] //'T00:00:00'
//         const selectedDateWithoutTime = new Date(selectedDate).setHours(0, 0, 0, 0);
//         const warning = document.getElementById('dateWarning');
        
//         if (selectedDateWithoutTime < minDateWithoutTime) {
//             // Show warning if date is too early
//             this.value = ''; // Clear the invalid selection
//             warning.classList.add('show');
//         } else {
//             // Hide warning and show selected date
//             warning.classList.remove('show');
//         }
//     });
    
//     // Additional validation on input
//     dateInput.addEventListener('input', function() {
//         const selectedDate = new Date(this.value);
//         const warning = document.getElementById('dateWarning');
        
//         if (this.value && selectedDate < minDate) {
//             warning.classList.add('show');
//         } else {
//             warning.classList.remove('show');
//         }
//     });
// }


$( document ).ready(function() {
    stickyFooter();
    // datePickerCPS();
});
$( window ).resize(function() {
    stickyFooter();
});